import React from 'react'
import type { Translation } from '../../i18n'
import { serif, warm900, warm700, warm500, cream, textMuted } from './tokens'

type Props = {
  l: Translation['landing']
  home: string
}

export const HeroSection: React.FC<Props> = ({ l, home }) => (
  <section className="grid md:grid-cols-2 min-h-[calc(100vh-72px)]" style={{ background: cream }}>
    <div className="flex flex-col justify-center px-10 md:px-20 py-24">
      <p className="flex items-center gap-3 text-[0.75rem] font-medium tracking-[0.18em] uppercase mb-6" style={{ color: warm500 }}>
        <span className="w-8 h-px inline-block" style={{ background: warm500 }} />
        Santa Maria da Feira · {l.historia.kicker}
      </p>
      <h1
        className="text-[clamp(3rem,5vw,4.5rem)] font-light leading-[1.08] mb-7 whitespace-pre-line"
        style={{ fontFamily: serif, color: warm900 }}
      >
        {l.heroTitle + '\n'}<em className="italic" style={{ color: warm500 }}>{l.heroTitleEm}</em>
      </h1>
      <p className="text-[1rem] leading-[1.75] max-w-[420px] mb-10" style={{ color: textMuted }}>
        {l.heroDesc}
      </p>
      <div className="flex gap-4 items-center flex-wrap">
        <a
          href={`${home}#produtos`}
          className="inline-block text-[0.82rem] font-medium tracking-[0.1em] uppercase px-8 py-3 rounded-[2px] no-underline transition-colors hover:opacity-90"
          style={{ background: warm700, color: cream }}
        >
          {l.cta.button}
        </a>
        <a
          href={`${home}#historia`}
          className="flex items-center gap-2 text-[0.82rem] font-medium tracking-[0.06em] no-underline transition-all hover:gap-3"
          style={{ color: warm700 }}
        >
          {l.nav.historia} →
        </a>
      </div>
    </div>
    <div className="relative overflow-hidden hidden md:block">
      <img
        src="/apps/ca/img/hero/cal_1.jpeg"
        alt=""
        aria-hidden
        className="w-full h-full object-cover object-bottom"
        style={{ animation: 'kenburns 12s ease-in-out infinite alternate' }}
      />
      <div
        className="absolute bottom-10 left-0 px-6 py-4 rounded-[0_2px_2px_0]"
        style={{ background: warm700, color: cream, fontFamily: serif, fontStyle: 'italic', fontSize: '0.95rem' }}
      >
        <strong className="block not-italic text-[0.7rem] tracking-[0.12em] uppercase mb-1" style={{ fontFamily: "'DM Sans', system-ui, sans-serif", fontWeight: 500, opacity: 0.75 }}>
          {l.heroBadge.title}
        </strong>
        {l.heroBadge.text}
      </div>
    </div>
  </section>
)
